<template>
  <div v-if="isAdmin">
    <nav-bar></nav-bar>
    <div class="container">
      <div class="section">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <li>
            {{ client && clientName + " > " }}
            {{ CONSTANTS.getCopy("CREATEWIDGET_BREADCRUMB") }}
          </li>
        </nav>
        <div class="create-widget-form">
          <label class="label">{{
            CONSTANTS.getCopy("CREATEWIDGET_FORM_LABEL")
          }}</label>
          <div class="is-flex-column-center">
            <div>
              <b>{{ CONSTANTS.getCopy("CREATEWIDGET_FORM_BACKGROUND") }}</b>
              <input type="color" v-model="widgetData.backgroundMessage" />
            </div>
            <div class="ptop-1">
              <b>{{ CONSTANTS.getCopy("CREATEWIDGET_FORM_BOT_BACKGROUND") }}</b>
              <input type="color" v-model="widgetData.botBoxMessageColor" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_USER_BACKGROUND")
              }}</b>
              <input type="color" v-model="widgetData.userBoxMessageColor" />
            </div>
            <div class="ptop-1">
              <b>{{ CONSTANTS.getCopy("CREATEWIDGET_FORM_BOT_TEXT_COLOR") }}</b>
              <input type="color" v-model="widgetData.botMessageTextColor" />
            </div>
            <div class="ptop-1">
              <b>{{ CONSTANTS.getCopy("CREATEWIDGET_FORM_BOT_LINK_COLOR") }}</b>
              <input type="color" v-model="widgetData.botLinkTextColor" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_USER_TEXT_COLOR")
              }}</b>
              <input type="color" v-model="widgetData.userMessageTextColor" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_HEADER_BACKGROUND")
              }}</b>
              <input type="color" v-model="widgetData.backgroundHeader" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_HEADER_TEXT_COLOR")
              }}</b>
              <input type="color" v-model="widgetData.headerTextColor" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy(
                  "CREATEWIDGET_FORM_SEND_MSG_SECTION_BACKGROUND"
                )
              }}</b>
              <input type="color" v-model="widgetData.backgroundFooter" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_INPUT_TEXT_COLOR")
              }}</b>
              <input type="color" v-model="widgetData.messageInputTextColor" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_INPUT_BORDER_COLOR")
              }}</b>
              <input
                type="color"
                v-model="widgetData.messageInputBorderColor"
              />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_SEND_BUTTON_COLOR")
              }}</b>
              <input type="color" v-model="widgetData.sendButtonColor" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy(
                  "CREATEWIDGET_FORM_SEND_BUTTON_BORDER_AND_TEXT_COLOR"
                )
              }}</b>
              <input
                type="color"
                v-model="widgetData.borderAndTextColorButton"
              />
            </div>
            <div class="ptop-1">
              <b>{{ CONSTANTS.getCopy("CREATEWIDGET_FORM_AVATAR_URL") }}</b>
              <input type="url" v-model="widgetData.avatarUrl" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_SHOW_ICON_BORDER_?")
              }}</b>
              <button @click="showIconBorderColor()">
                {{
                  CONSTANTS.getCopy("CREATEWIDGET_FORM_SHOW_ICON_BORDER_YES")
                }}
              </button>
              <button @click="hideIconBorderColor()">
                {{ CONSTANTS.getCopy("CREATEWIDGET_FORM_SHOW_ICON_BORDER_NO") }}
              </button>
              <div class="ptop-1" v-if="widgetData.showIconBorderColor">
                <b>{{
                  CONSTANTS.getCopy("CREATEWIDGET_FORM_ICON_BORDER_COLOR")
                }}</b>
                <input type="color" v-model="widgetData.iconBorderColor" />
              </div>
            </div>
            <div class="ptop-1">
              <b>{{ CONSTANTS.getCopy("CREATEWIDGET_FORM_BOT_TITLE") }}</b>
              <input type="text" v-model="widgetData.botTitle" />
            </div>
            <div class="ptop-1">
              <b>{{ CONSTANTS.getCopy("CREATEWIDGET_FORM_BOT_SUBTITLE") }}</b>
              <input type="text" v-model="widgetData.botSubtitle" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_BOT_INITIAL_MSG")
              }}</b>
              <input type="text" v-model="widgetData.startBotMessage" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_USER_INITIAL_MSG")
              }}</b>
              <input type="text" v-model="widgetData.startUserMessage" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_INPUT_PLACEHOLDER")
              }}</b>
              <input type="text" v-model="widgetData.placeholderText" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_ALERT_BACKGROUND_COLOR")
              }}</b>
              <input type="color" v-model="widgetData.backgroundInfoBox" />
            </div>
            <div class="ptop-1">
              <b>{{
                CONSTANTS.getCopy("CREATEWIDGET_FORM_ALERT_TEXT_COLOR")
              }}</b>
              <input type="color" v-model="widgetData.infoBoxTextColor" />
            </div>
            <div class="ptop-1">
              <b>{{ CONSTANTS.getCopy("CREATEWIDGET_FORM_ALERT_TEXT") }}</b>
              <input type="text" v-model="widgetData.infoBoxText" />
            </div>
            <div class="ptop-1">
              <div class="button is-primary" @click="saveWidget">
                {{ CONSTANTS.getCopy("CREATEWIDGET_FORM_SAVE_BUTTON") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="widget-bot-icon">
      <div
        class="bot-help"
        v-show="showInfoBox"
        @click="hideInfoBox"
        :style="{
          background: widgetData.backgroundInfoBox,
          color: widgetData.infoBoxTextColor,
        }"
      >
        <div class="close-container"><div class="close">x</div></div>
        {{ widgetData.infoBoxText }}
      </div>
      <img
        class="avatar"
        :style="{
          border: widgetData.showIconBorderColor
            ? '2px solid ' + widgetData.iconBorderColor
            : 'none',
        }"
        :src="widgetData.avatarUrl"
        alt="Avatar"
        @click="toggleChat"
      />
    </div>
    <div v-if="showChat" id="chat-widget">
      <div class="header" :style="{ background: widgetData.backgroundHeader }">
        <!--<img class="avatar" :src="widgetData.avatarUrl" alt="Avatar">-->
        <div class="title-custom-container">
          <span
            class="title-custom"
            :style="{ color: widgetData.headerTextColor }"
            >{{
              widgetData.botTitle ? widgetData.botTitle : "Título bot"
            }}</span
          >
          <span
            class="subtitle-custom"
            :style="{ color: widgetData.headerTextColor }"
            >{{ widgetData.botSubtitle }}</span
          >
        </div>
        <button
          @click="showChatSubmenu = !showChatSubmenu"
          class="header-button"
          :style="{ color: widgetData.headerTextColor }"
        >
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path
              :fill="widgetData.headerTextColor"
              d="m16.5 11.995c0-1.242 1.008-2.25 2.25-2.25s2.25 1.008 2.25 2.25-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25zm-6.75 0c0-1.242 1.008-2.25 2.25-2.25s2.25 1.008 2.25 2.25-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25zm-6.75 0c0-1.242 1.008-2.25 2.25-2.25s2.25 1.008 2.25 2.25-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25z"
            />
          </svg>
        </button>
        <div v-show="showChatSubmenu" class="chat-submenu">
          <span @click="toggleFullScreen">{{
            CONSTANTS.getCopy("CREATEWIDGET_CHATSUBMENU_FULL_SCREEN")
          }}</span>
          <span
            >{{ CONSTANTS.getCopy("CREATEWIDGET_CHATSUBMENU_FONT_SIZE")
            }}<span class="fs-S">S</span> | M | <span class="fs-L">L</span>
          </span>
          <span>{{
            CONSTANTS.getCopy("CREATEWIDGET_CHATSUBMENU_HIGH_CONTRAST")
          }}</span>
          <span>{{
            CONSTANTS.getCopy("CREATEWIDGET_CHATSUBMENU_DELETE_CHAT")
          }}</span>
        </div>
        <button class="header-button" @click="toggleChat">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path
              :fill="widgetData.headerTextColor"
              d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"
            />
          </svg>
        </button>
      </div>
      <div
        class="messages"
        :style="{ background: widgetData.backgroundMessage }"
      >
        <div class="message-widget bot-message">
          <div
            class="message-text-widget"
            :style="{
              color: widgetData.botMessageTextColor,
              background: widgetData.botBoxMessageColor,
            }"
          >
            {{ widgetData.startBotMessage }}
          </div>
        </div>
        <div class="message-widget user-message">
          <div
            class="message-text-widget"
            :style="{
              color: widgetData.userMessageTextColor,
              background: widgetData.userBoxMessageColor,
            }"
          >
            {{ CONSTANTS.getCopy("CREATEWIDGET_USER_INFO_BOX") }}
          </div>
        </div>
        <div class="message-widget bot-message">
          <div
            class="message-text-widget"
            :style="{
              color: widgetData.botMessageTextColor,
              background: widgetData.botBoxMessageColor,
            }"
          >
            {{ CONSTANTS.getCopy('CREATEWIDGET_BOT_INFO_BOX') }}
          </div>
        </div>
        <div class="message-widget bot-message">
          <div
            class="message-text-widget"
            :style="{ background: widgetData.botBoxMessageColor }"
          >
            <a
              href="https://www.google.es"
              target="_blank"
              :style="{ color: widgetData.botLinkTextColor }"
              style="text-decoration: underline"
              >https://www.google.es</a
            >
          </div>
        </div>
        <div class="message-widget buttons-message">
          <div
            class="message-button"
            :style="{
              color: widgetData.borderAndTextColorButton,
              'border-color': widgetData.borderAndTextColorButton,
            }"
          >
            Carlos
          </div>
          <div
            class="message-button"
            :style="{
              color: widgetData.borderAndTextColorButton,
              'border-color': widgetData.borderAndTextColorButton,
            }"
          >
            Javier
          </div>
          <div
            class="message-button"
            :style="{
              color: widgetData.borderAndTextColorButton,
              'border-color': widgetData.borderAndTextColorButton,
            }"
          >
            Samu
          </div>
          <div
            class="message-button"
            :style="{
              color: widgetData.borderAndTextColorButton,
              'border-color': widgetData.borderAndTextColorButton,
            }"
          >
            Helen
          </div>
          <div
            class="message-button"
            :style="{
              color: widgetData.borderAndTextColorButton,
              'border-color': widgetData.borderAndTextColorButton,
            }"
          >
            Jorge
          </div>
          <div
            class="message-button"
            :style="{
              color: widgetData.borderAndTextColorButton,
              'border-color': widgetData.borderAndTextColorButton,
            }"
          >
            Hola
          </div>
          <div
            class="message-button"
            :style="{
              color: widgetData.borderAndTextColorButton,
              'border-color': widgetData.borderAndTextColorButton,
            }"
          >
            Adios
          </div>
        </div>
        <!-- más mensajes aquí -->
      </div>
      <div
        class="widget-input"
        :style="{ background: widgetData.backgroundFooter }"
      >
        <input
          type="text"
          id="chat-input"
          :placeholder="widgetData.placeholderText"
          :style="{
            '--placeholder-color': widgetData.messageInputTextColor,
            color: widgetData.messageInputTextColor,
            'border-color': widgetData.messageInputBorderColor,
            background: widgetData.backgroundFooter,
          }"
        />
        <svg
          class="send-button"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            :fill="widgetData.sendButtonColor"
            d="M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z"
          />
        </svg>
      </div>
    </div>
    <WidgetCode :widgetData="widgetData" :idProject="idProject"></WidgetCode>
  </div>
</template>

<script>
import '../../css/widgets.css'
import WidgetCode from './WidgetCode'
import Auth from '../../models/auth'
import CONSTANTS from '../../constants'

export default {
  components: { WidgetCode },
  data () {
    return {
      widgetData: {
        botTitle: null,
        botSubtitle: null,
        avatarUrl: null,
        startBotMessage: null,
        startUserMessage: null,
        showIconBorderColor: false,
        iconBorderColor: '#ffffff',
        placeholderText: null,
        backgroundMessage: '#ffffff',
        userMessageTextColor: '#000000',
        botMessageTextColor: '#000000',
        botLinkTextColor: '#000000',
        botBoxMessageColor: '#e1ffe1',
        userBoxMessageColor: '#d7e2f1',
        backgroundHeader: '#f5f5f5',
        headerTextColor: '#000000',
        messageInputTextColor: '#000000',
        messageInputBorderColor: '#000000',
        sendButtonColor: '#000000',
        backgroundInfoBox: '#cbcce6',
        infoBoxTextColor: '#000000',
        borderAndTextColorButton: '#000000',
        backgroundFooter: '#ffffff',
        infoBoxText: null
      },
      clientName: null,
      showChatSubmenu: false,
      showChat: true,
      isFullScreen: false,
      showInfoBox: true,
      idProject: null,
      client: this.$route.params.client
    }
  },
  created () {
    this.breadcrumbDetails()
    this.api
      .post('/WidgetDataGet', { idClient: this.client ? parseInt(this.client) : 0 })
      .then((response) => {
        if (response && response.widgetData) {
          this.widgetData = response.widgetData
          this.idProject = response.widgetData.idProject
          if (!this.widgetData.infoBoxText) {
            this.widgetData.infoBoxText = CONSTANTS.getCopy(
              'CREATEWIDGET_USER_INFO_BOX'
            )
          }
        }
      })
  },
  computed: {
    userName () {
      return localStorage.getObject('user.name', false)
    },
    isAdmin () {
      return Auth.isAdmin()
    }
  },
  methods: {
    breadcrumbDetails () {
      if (this.client) {
        this.api
          .post('/ClientById/', { idClient: this.client })
          .then((response) => {
            this.clientName = response.client.name
          })
      }
    },
    showWidget () {
      return (
        this.userName === 'agrotechAdmin' ||
        this.userName === 'BotDemoClientesAdmin' ||
        this.userName === 'juntacylAdmin'
      )
    },
    generateWidget () {
      this.showWidgetCode = true
    },
    toggleChat () {
      this.showChat = !this.showChat
    },
    toggleFullScreen () {
      this.showChatSubmenu = !this.showChatSubmenu
      let chatWidget = document.getElementById('chat-widget')
      if (this.isFullscreen) {
        chatWidget.classList.remove('fullscreen')
      } else {
        chatWidget.classList.add('fullscreen')
      }

      this.isFullscreen = !this.isFullscreen
    },
    hideInfoBox () {
      this.showInfoBox = false
    },
    saveWidget () {
      this.widgetData.idClient = this.client ? parseInt(this.client) : 0
      this.api
        .post('/WidgetDataRegister', this.widgetData)
        .then((response) => {})
    },
    showIconBorderColor () {
      this.widgetData.showIconBorderColor = true
      this.$forceUpdate()
    },
    hideIconBorderColor () {
      this.widgetData.showIconBorderColor = false
      this.$forceUpdate()
    }
  }
}
</script>

<style>
.create-widget-form input[type="color"],
.create-widget-form input[type="url"],
.create-widget-form input[type="text"] {
  width: 15%;
  padding: 0px;
  border-radius: 4px;
  height: 30px;
  background-color: #fff;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.create-widget-form input[type="url"],
.create-widget-form input[type="text"] {
  padding: 6px;
  width: 30%;
}

#chat-input {
  --placeholder-color: black;
}
#chat-input::placeholder {
  color: var(--placeholder-color);
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/CreateWidget.vue